module.exports = __webpack_public_path__ + "static/media/透明底logo-2.b56ee877.png";